import { createContext, useState, useContext } from 'react'

const ConnectionContext = createContext();
const ConnectionProvider = ({ children }) => {
  // TODO: Add logic here to detect wifi conection eventually?
  return (
    <ConnectionContext.Provider value={{  }}>
      {children}
    </ConnectionContext.Provider>
  )
}

const useConnectionContext = () => useContext(ConnectionContext)

export default useConnectionContext

export { ConnectionContext, ConnectionProvider, useConnectionContext }
